import { api } from "..";

export function getBolsRequest({ params }) {
  return api.get(`/v1/bol`, {
    params,
  });
}
